import { useAuth } from "@/contexts/auth-context";
import { formatCurrency as formatCurrencyUtil, type CurrencyCode } from "@/lib/currency";

/**
 * Hook to format currency using user's preferred currency
 */
export function useCurrency() {
  const { user } = useAuth();
  const currency = (user?.currency || "IDR") as CurrencyCode;

  const formatCurrency = (amount: number) => {
    return formatCurrencyUtil(amount, currency);
  };

  return {
    currency,
    formatCurrency,
  };
}

